import { getEnv } from "@trillion/ui/lib/env";
import { createApiClient } from "@trillion/ui/lib/api-client";
import type {
  TrafficIntent,
  PaginatedResponse,
  IntentStats,
  IntentListParams,
  IntentCreateData,
  IntentUpdateData,
} from "@/types";

const api = createApiClient(() => getEnv("CORTEX_API_URL"));

export const adminApi = {
  intents: {
    async list(params: IntentListParams = {}): Promise<PaginatedResponse<TrafficIntent>> {
      const searchParams = new URLSearchParams();
      if (params.page) searchParams.set("page", String(params.page));
      if (params.pageSize) searchParams.set("pageSize", String(params.pageSize));
      if (params.sourceType) searchParams.set("sourceType", params.sourceType);
      if (params.topic) searchParams.set("topic", params.topic);
      if (params.sortBy) searchParams.set("sortBy", params.sortBy);
      if (params.sortDesc !== undefined) searchParams.set("sortDesc", String(params.sortDesc));

      const qs = searchParams.toString();
      return api.request<PaginatedResponse<TrafficIntent>>(
        `/admin/intents${qs ? `?${qs}` : ""}`
      );
    },

    async get(id: number): Promise<TrafficIntent> {
      return api.request<TrafficIntent>(`/admin/intent/${id}`);
    },

    async create(data: IntentCreateData): Promise<TrafficIntent> {
      return api.request<TrafficIntent>("/admin/intent", {
        method: "POST",
        body: JSON.stringify(data),
      });
    },

    async update(id: number, data: IntentUpdateData): Promise<void> {
      return api.request<void>(`/admin/intent/${id}`, {
        method: "PUT",
        body: JSON.stringify(data),
      });
    },

    async delete(id: number): Promise<void> {
      return api.request<void>(`/admin/intent/${id}`, { method: "DELETE" });
    },

    async stats(): Promise<IntentStats> {
      return api.request<IntentStats>("/admin/intents/stats");
    },
  },
};
